export default __webpack_public_path__ + "static/media/swap.1b8d20c7.png";